import { getAuthenticatedAxios } from "../../../utils/api";
import { normalizeHistoryDetails } from "../utils/historyPaperNormalization";

export const fetchSearchHistoryDetails = async (searchId) => {
  const authAxios = getAuthenticatedAxios();
  const response = await authAxios.get(`/api/v1/search-history/${searchId}/details`);
  return normalizeHistoryDetails(response.data);
};

export const buildHistoryMessages = ({
  searchDetails,
  loadedSummary,
  criteriaSummaryMessage,
}) => {
  const now = Date.now();
  const criteriaSet = Array.isArray(searchDetails.criteria_set)
    ? searchDetails.criteria_set
    : [];
  const criteriaMessage =
    criteriaSet.length > 0
      ? [
          {
            id: now + 1,
            type: "criteria_confirmation",
            runId: searchDetails.id,
            threadId: searchDetails.id,
            criteriaDraft: criteriaSet,
            promptMessage: criteriaSummaryMessage,
            pending: false,
            locked: true,
            error: null,
          },
        ]
      : [];
  const resultMessageId = now + 1 + criteriaMessage.length;

  return [
    { id: now, type: "user", content: searchDetails.query },
    ...criteriaMessage,
    {
      id: resultMessageId,
      type: "result",
      papers: searchDetails.papers,
      query: searchDetails.query,
      summary: loadedSummary,
      queries_used: searchDetails.queries || searchDetails.search_queries_used,
      total_found: searchDetails.total_pmids_found || searchDetails.papers.length,
      search_mode: searchDetails.search_mode || "",
      search_type: searchDetails.search_type || "",
      preference: searchDetails.preference,
      ...(criteriaSet.length > 0 ? { criteria_set: criteriaSet } : {}),
      isHistory: true,
      ai_overview: searchDetails.ai_overview,
    },
  ];
};
